import { defineMessages } from "react-intl";

export default defineMessages({
  coverage: {
    id: "policycommon.component.coverage.Coverage",
    defaultMessage: "Coverage",
  },
  limits: {
    id: "policycommon.component.coverage.Limits",
    defaultMessage: "Limits",
  },
  limits: {
    id: "policycommon.component.coverage.Limit",
    defaultMessage: "Limit",
  },
  deductible: {
    id: "policycommon.component.coverage.Deductible",
    defaultMessage: "Deductible",
  },
  policyNumber: {
    id: "policycommon.component.coverage.Premium",
    defaultMessage: "Premium",
  },
  coverageName: {
    id: "policycommon.component.coverage.Coverage Name",
    defaultMessage: "Coverage Name",
  },
  limitWidthDollar: {
    id: "policycommon.component.coverage.Limit ($)",
    defaultMessage: "Limit ($)",
  },
  deductibleWidthDollar: {
    id: "policycommon.component.coverage.Deductible ($)",
    defaultMessage: "Deductible ($)",
  },
  premiumWidthDollar: {
    id: "policycommon.component.coverage.Premium ($)",
    defaultMessage: "Premium ($)",
  }
   
});